/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React, {useState} from "react";
import "components/elements/main/index.scss";
import { Box } from "@mui/material";
import { getURI } from "helpers/utils";
import ButtonComponent from "components/Button";

const ShopHeaderBack = (props) => {

    const {
        onCancel, history
    } = props;

    const handleBack = () => {
        history.goBack();
    };

    return (
        <Box mb={2} width="100%" display="flex">
            <Box width="25%" alignItems="left">
                <ButtonComponent
                    sx={{p: 1, minWidth: 'auto'}}
                    type="primary"
                    variant="outlined"
                    name="< Back"
                    size="medium"
                    onClick={onCancel ? onCancel : handleBack}
                />
            </Box>
            <Box width="75%" display="flex" justifyContent="center" alignItems="center" >
            </Box>
        </Box>
    );
};

export default ShopHeaderBack;
